import { Box } from '@mui/material'
import { forwardRef } from 'react'
import { pressableResetSx } from './pressableSx'

/**
 * Accessible interactive surface primitive (button by default).
 *
 * @typedef {Object} PressableProps
 * @property {string} [as] DOM tag, defaults to `'button'`.
 * @property {React.ReactNode} [children]
 * @property {string} [aria-label]
 * @property {boolean} [disabled]
 * @property {(e: React.MouseEvent) => void} [onClick]
 * @property {object} [sx] MUI sx prop (merged with reset + focus ring).
 */
const Pressable = forwardRef(function Pressable(
  { as = 'button', children, sx, type, ...rest },
  ref,
) {
  const isButton = as === 'button'
  return (
    <Box
      component={as}
      ref={ref}
      type={isButton ? (type ?? 'button') : type}
      sx={{ ...pressableResetSx, ...sx }}
      {...rest}
    >
      {children}
    </Box>
  )
})

export default Pressable
